'use strict';
var angular:angular.IAngularStatic =  require('angular');
angular.module('primo-explore.infra').directive('contenteditable', Contenteditable);


function Contenteditable() {
    return {
      restrict: "A",
      require: "ngModel",
      link: function(scope, element, attrs, ngModel) {

        function read() {
          ngModel.$setViewValue(element.html());
        }

        ngModel.$render = function() {
          element.html(ngModel.$viewValue || "");
        };

        element.bind("blur keyup change", function() {
          scope.$apply(read);
        });
      }
    };
  }



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/contenteditable.directive.ts